import PropTypes from "prop-types";
import React from "react";
import Button from "web/react/components/button/button";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import MultiplyOnHoverButton from "web/react/components/buttons/multiply-on-hover-button/multiply-on-hover-button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import analytics from "web/script/analytics/analytics";
import styles from "./buy-on-store-button.css";

export function BuyOnStoreButton({
    leadUrl,
    leadLabel,
    openCustomerCaptureOverlay,
    productId,
    reason,
    beforeOnClick,
    bingTraffic,
    overrideStyles,
}) {
    function onClickBuyNow() {
        analytics.event("buy_area", "clicked", "buy-on-store-button");

        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openCustomerCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }

    let button = (
        <MultiplyOnHoverButton className={overrideStyles.buttonMultiply} fullHeight fullWidth>
            {leadLabel}
        </MultiplyOnHoverButton>
    );

    if (bingTraffic === false) {
        button = (
            <Button
                styleType="secondary"
                className={overrideStyles.buttonBuyNow}
                fullHeight
                fullWidth
            >
                {leadLabel}
            </Button>
        );
    }

    return (
        <LeadLink
            beforeOnClick={beforeOnClick}
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            {button}
        </LeadLink>
    );
}

BuyOnStoreButton.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    openCustomerCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
    beforeOnClick: PropTypes.func,
    bingTraffic: PropTypes.bool,
    overrideStyles: PropTypes.shape({
        buttonMultiply: PropTypes.string,
        buttonBuyNow: PropTypes.string,
    }),
};

BuyOnStoreButton.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button",
    overrideStyles: {
        buttonMultiply: styles.buttonMultiply,
        buttonBuyNow: styles.buttonBuyNow,
    },
};

export default withReduxProvider(connect(null, { openCustomerCaptureOverlay })(BuyOnStoreButton));
